import { render, staticRenderFns } from "./Cep.vue?vue&type=template&id=a05f6f74"
import script from "./Cep.vue?vue&type=script&lang=js"
export * from "./Cep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports